import React from "react";

import VehicleOwnerContingents from "../vehicleOwner/VehicleOwnerContingents";
import VehicleOwnerPrices from "../vehicleOwner/VehicleOwnerPrices";
import BikeSharingCalendar from "./BikeSharingCalendar";

interface Props {
    settings: any,
    setSettings: any
}
const BikeSharing = (props: Props) => {
    const { settings, setSettings } = props;
    return (
        <>
            <form className="off-content row">
                <BikeSharingCalendar
                    settings={settings}
                    setSettings={setSettings}
                    key={"vehicleOwnerCalendar"}
                />
                <VehicleOwnerContingents
                    settings={settings}
                    setSettings={setSettings}
                    key={"vehicleOwnerContingents"}
                />
                <VehicleOwnerPrices
                    settings={settings}
                    setSettings={setSettings}
                    key={"vehicleOwnerPrices"}
                />
            </form>
        </>
    );
}

export default BikeSharing;